import { Navigate, useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { useAuth } from "@/lib/auth/AuthContext";
import { Button } from "@/components/ui";
import { AuthLayout } from "./AuthLayout";

export function SessionExpiredPage() {
  const { state, resetToLogin } = useAuth();
  const navigate = useNavigate();

  if (state.status !== "session_expired") {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout
      icon={<Clock className="h-6 w-6" aria-hidden="true" />}
      title="Tu sesion ha caducado"
      description="Por seguridad, cierra sesion tras un periodo de inactividad. Vuelve a iniciar sesion para continuar."
    >
      <Button
        className="w-full"
        onClick={() => {
          resetToLogin();
          navigate("/login", { replace: true });
        }}
      >
        Volver a iniciar sesion
      </Button>
    </AuthLayout>
  );
}
